<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Lionheart: A Beacon of Hope</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#in-the-beginning">In the Beginning…</a></li>
<li id="toc-li-6"><a href="#/text/ch006#brief-encounter">Brief Encounter</a></li>
<li id="toc-li-7"><a href="#/text/ch007#the-difference-maker">The Difference Maker</a></li>
<li id="toc-li-8"><span href="#/text/ch008#preparation" title="Link target outside of Sample">Preparation</span></li>
<li id="toc-li-9"><span href="#/text/ch009#eve-of-departure" title="Link target outside of Sample">Eve of Departure</span></li>
<li id="toc-li-10"><span href="#/text/ch010#river-borne-and-seabound" title="Link target outside of Sample">River-Borne and Seabound</span></li>
<li id="toc-li-11"><span href="#/text/ch011#physical-change" title="Link target outside of Sample">Physical Change</span></li>
<li id="toc-li-12"><span href="#/text/ch012#the-ocean" title="Link target outside of Sample">The Ocean</span></li>
<li id="toc-li-13"><span href="#/text/ch013#the-storm" title="Link target outside of Sample">The Storm</span></li>
<li id="toc-li-14"><span href="#/text/ch014#the-valley" title="Link target outside of Sample">The Valley</span></li>
<li id="toc-li-15"><span href="#/text/ch015#homeward-bound" title="Link target outside of Sample">Homeward Bound</span></li>
<li id="toc-li-16"><span href="#/text/ch016#lost-and-adrift" title="Link target outside of Sample">Lost and Adrift</span></li>
<li id="toc-li-17"><span href="#/text/ch017#turning-point" title="Link target outside of Sample">Turning Point</span></li>
<li id="toc-li-18"><span href="#/text/ch018#darkness-radiates-light" title="Link target outside of Sample">Darkness Radiates Light</span></li>
<li id="toc-li-19"><span href="#/text/ch019#human-encounter" title="Link target outside of Sample">Human Encounter</span></li>
<li id="toc-li-20"><span href="#/text/ch020#final-briefing" title="Link target outside of Sample">Final Briefing</span></li>
<li id="toc-li-21"><span href="#/text/ch021#the-home-stretch" title="Link target outside of Sample">The Home Stretch</span></li>
<li id="toc-li-22"><span href="#/text/ch022#home" title="Link target outside of Sample">Home</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?1001d704